export default (props = {}) => <svg width="13" height="9" viewBox="0 0 13 9" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M7.29241 7.97063C6.8921 8.49064 6.10789 8.49064 5.70759 7.97063L0.811169 1.60999C0.304972 0.952424 0.773737 -1.19999e-06 1.60358 -1.12744e-06L11.3964 -2.71323e-07C12.2263 -1.98776e-07 12.695 0.952425 12.1888 1.60999L7.29241 7.97063Z" fill="white"/>
</svg>
